import { render, staticRenderFns } from "./navbarsection.vue?vue&type=template&id=c0aa1170&"
import script from "./navbarsection.vue?vue&type=script&lang=js&"
export * from "./navbarsection.vue?vue&type=script&lang=js&"
import style0 from "./navbarsection.vue?vue&type=style&index=0&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports